import React, { ReactNode } from "react";

interface ActionSvgContainerProps {
  label?: string;
  children: ReactNode;
}

export const ActionSvgContainer = ({ label, children }: ActionSvgContainerProps) => {
  return (
    <svg width={65} height={50} role="button">
      {children}
      {label && <title>{label}</title>}
    </svg>
  );
};
